<template>
  <span v-if="country && locale && country.columns.shortTitle">{{ country.columns.shortTitle[locale.columns.language] }}</span>
  <span v-else>Country Missing</span>
</template>

<script>
import consola from 'consola'

const logger = consola.withTag('Current Language')

export default {
  props: {
    country: {
      type: Object,
      default: () => {}
    },
    locale: {
      type: Object,
      default: () => {}
    }
  },
  created () {
    if (!this.country) {
      logger.error('Missing Country or Locale - make sure your .env Token has proper permission')
    }
  }
}
</script>
